import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { updateSurveyToFillQuestion } from '../../../../../../store/actions/dataEntryFillASurveyActions';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

const SurveyMultipleChoiceQuestion = ({ question, onChangeAlert, disabled }) => {
  const dispatch = useDispatch();
  const { variant, options, answer, id, error } = question;
  const [selectedOptions, setSelectedOptions] = useState(answer || []);

  const handleCheckClick = (newValue) => {
    if (!disabled) {
      let castValue = variant?.value === 'numeric' ? Number(newValue || 0) : newValue;
      let newOptions = [];

      if (selectedOptions.includes(castValue)) {
        newOptions = selectedOptions.filter((option) => option !== castValue);
      } else {
        newOptions = [...selectedOptions, castValue];
      }

      dispatch(
        updateSurveyToFillQuestion({
          questionId: id,
          newData: { answer: newOptions || [], error: null }
        })
      );

      onChangeAlert();
    }
  };

  useEffect(() => {
    setSelectedOptions(answer || []);
  }, [answer]);

  return (
    <>
      <div>
        <FormGroup>
          {options &&
            options.map((item) => (
              <FormControlLabel
                onClick={() => handleCheckClick(item?.value)}
                key={item?.value}
                control={
                  <Checkbox
                    disabled={disabled}
                    style={{ color: '#32668D' }}
                    checked={selectedOptions.includes(item?.value)}
                  />
                }
                label={item?.option}
              />
            ))}
        </FormGroup>
        {error && <p className='survey-question__error-hint'>{error}</p>}
      </div>
    </>
  );
};

export default SurveyMultipleChoiceQuestion;
